import { SvgIcon } from '@mui/material'

const SvgTaskssidebar = (props) => (
  <SvgIcon viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg" name="SvgTaskssidebar" {...props}>
    <style>{'.taskssidebar_svg__st1{fill:#faa515}.taskssidebar_svg__st3{fill:#e6e6e6}'}</style>
    <path
      d="M54.728 6.181v56.531c0 .711-.577 1.288-1.288 1.288H10.559a1.288 1.288 0 01-1.288-1.288V6.181c0-.711.577-1.288 1.288-1.288H53.44c.711 0 1.288.577 1.288 1.288z"
      fill="#fad207"
    />
    <path
      className="taskssidebar_svg__st1"
      d="M11.332 11.248v49.78c0 .504.408.912.912.912h25.983c.342 0 .669-.136.911-.377l9.925-9.925V10.559H13.898l-.217-1.567-1.776 1.185a1.288 1.288 0 00-.573 1.071z"
    />
    <path
      d="M50.865 10.044v39.791l-7.726 2.833-2.575 7.469H14.423a1.288 1.288 0 01-1.288-1.288V10.044c0-.711.577-1.288 1.288-1.288h35.155a1.288 1.288 0 011.287 1.288z"
      fill="#f5f5f5"
    />
    <path
      className="taskssidebar_svg__st3"
      d="M50.865 49.835L40.563 60.137v-9.014c0-.711.577-1.288 1.288-1.288h9.014zM44.96 8.757v2.502a3.224 3.224 0 01-3.219 3.219H22.26a3.224 3.224 0 01-3.219-3.219V8.757H44.96z"
    />
    <path className="taskssidebar_svg__st1" d="M19.04 4.893h25.92v3.863H19.04V4.893z" />
    <path
      d="M43.028 4.891v6.367c0 .711-.577 1.288-1.288 1.288H22.26a1.288 1.288 0 01-1.288-1.288V4.891h7.148a4.037 4.037 0 01-.086-1.287 3.983 3.983 0 117.846 1.287h7.148z"
      fill="#50758d"
    />
    <path
      d="M30.316 42.785a2.354 2.354 0 01-1.633-.658l-5.96-5.654a2.356 2.356 0 113.266-3.396l4.186 3.948 9.701-11.012a2.356 2.356 0 113.536 3.116L32.084 41.987a2.354 2.354 0 01-1.768.798z"
      fill="#4caf50"
    />
  </SvgIcon>
)

export default SvgTaskssidebar
